// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"LM-z","carouselContainer":"MM-z"};